import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './ReportListItem';
import ReportDownloadDialog from './ReportDownloadDialog';
import FlatButton from "material-ui/FlatButton";
import UpIcon from "material-ui/svg-icons/hardware/keyboard-arrow-up";
import DownIcon from "material-ui/svg-icons/hardware/keyboard-arrow-down";

import ScheduleIcon from 'material-ui/svg-icons/action/schedule';

import ReportActions from '../../actions/ReportActionCreator';
import ReportStore from '../../stores/ReportStore';

import buildContextMenu from "../Common/BuildContextMenu";

class ReportList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            reports: ReportStore.getAll(),
            count: 0,
            page: 0,
            limit: 50,
            sortCriteria: null,
            sortMapCriteria: null,
            showButton: false,
            loading: false,
            fetchedAll: false,
            actions: buildContextMenu([
                {
                    link: '/dashboard/reports/schedules',
                    icon: <ScheduleIcon/>,
                    label: 'Scheduled reports'
                }
            ], this.context.auth)
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.sort = this.sort.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        ReportStore.addChangeListener(this.onChange);
        ReportActions.getAll({limit: this.state.limit});
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        ReportStore.removeChangeListener(this.onChange);
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
        return (
            <div ref="reportList">
                <ListView
                    title="Reports"
                    sortOptions={this.props.sortOptions}
                    sortAction={this.sort}
                    searchAction={ReportActions.search}
                    items={this.state.reports}
                    itemDecorator={ListItem}
                    newEntityUrl={this.context.auth.isAdmin() ? '/dashboard/report/new' : ''}
                    actions={this.state.actions}
                >
                    <ReportDownloadDialog/>
                </ListView>
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.loading}
                        fullWidth
                    />
                )}
            </div>
        );
    }

    onChange() {
        if (ReportStore.fetchedAll()) {
            this.setState({fetchedAll: true, loading: false});
        } else {
            const reports = ReportStore.getAll({limit: this.state.limit});
            if (!!reports) {
                if (reports.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                    this.setState({reports, loading: false});
                } else {
                    const mapped = reports.map(this.state.sortMapCriteria);
                    mapped.sort(this.state.sortCriteria);
                    const sortedReports = mapped.map((el) => reports[el.index]);
                    this.setState({reports: sortedReports, loading: false});
                }
            }
        }
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'dateAdded':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateAdded)});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        ReportActions.getAll({sort: options.sort});
    }

    loadNextPage() {
        if (this.state.loading) { return; } //guard

        const page = this.state.page + 1;
        ReportActions.getAll({page, limit: this.state.limit});
        this.setState({page, loading: true});
    }

    handleScroll() {
        if (!this.state.showButton && window.scrollY > 0) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.reportList.clientHeight) {
            this.loadNextPage();
        }
    }
}

ReportList.contextTypes = {
    auth: PropTypes.object.isRequired
};

ReportList.defaultProps = {
    sortOptions: [
        {label: "Name", value: 'name'},
        {label: "Created", value: 'dateAdded'},
    ]
};

export default ReportList;
